import {type} from "@colyseus/schema";
import {nanoid} from "nanoid";
import {Cook} from "./cooks";
import {Basket} from "./basket";
import {GameSchema} from "./game_element_schema";

export enum IngredientTypes {
    TOMATO = "tomato",
    SALAD = "salad",
    ONION = "onion",
    CHOPPED_TOMATO = "chopped_tomato",
    CHOPPED_SALAD = "chopped_salad",
    CHOPPED_ONION = "chopped_onion",
    TOMATO_SALAD = "tomato_salad",
    MIXED_SALAD = "mixed_salad",
    TOMATO_SOUP = "tomato_soup",
    ONION_SOUP = "onion_soup",
    VEGGIE_MIX = "veggie_mix",
    VEGGIE_STEW = "veggie_stew",
    BURNT = "burnt"
}

export class Ingredient extends GameSchema {
    @type("string") type: IngredientTypes

    @type('string') carrier_id: string
    carrier: Cook
    onBasket: Basket

    constructor(x: number, y: number, type: IngredientTypes, basket?: Basket) {
        super();
        this.id = nanoid(8)
        this.type = type
        this.rest(x, y)
        this.onBasket = basket
    }

    rest(x: number, y: number) {
        this.carrier_id = undefined
        this.x = x
        this.y = y
    }

    beCarried(cook: Cook) {
        if (this.carrier_id == cook.id)
            return
        this.carrier = cook
        this.carrier_id = cook.id
        this.x = 0
        this.y = 0

        this.onBasket?.bye()
    }

    beDropped() {
        if (this.isResting())
            return
        this.carrier_id = undefined
        this.carrier = undefined
    }

    isResting(): boolean { return this.carrier_id == undefined }

    toString(): string {
        return `${this.printableId}(${(this.printableState)})`
    }

    get printableId(): string {
        return `${this.type}-${this.id}`;
    }

    valueOf = () => (this.toString());

    get printableState(): string { return this.isResting() ? `x:${this.x},y:${this.y}` : `carried by ${this.carrier.printableId}` }

}
